export var SalesAllReportMapper = function (data) {
    var groupListEntity = {
        groupList: [],
        apiData: data,
    };
    if (data && (data === null || data === void 0 ? void 0 : data.length) > 0) {
        var groupList_1 = [];
        data.map(function (record) {
            if (!groupList_1.includes(record.kpi_group)) {
                groupList_1.push(record.kpi_group);
                var groupEntityRecord = {
                    groupName: record.kpi_group,
                    subReportGroupList: [],
                };
                groupListEntity.groupList.push(groupEntityRecord);
            }
        });
        groupListEntity.groupList.sort(function (a, b) {
            return a.groupName.localeCompare(b.groupName);
        });
        groupListEntity.groupList = groupListEntity.groupList.map(function (record) {
            data
                .filter(function (subRecord) { return subRecord.kpi_group === record.groupName; })
                .map(function (subRecord) {
                var subGroupRecord = {
                    id: subRecord.kpi_id,
                    name: subRecord.kpi_name,
                };
                record.subReportGroupList.push(subGroupRecord);
            });
            record.subReportGroupList.sort(function (a, b) { return a.name.localeCompare(b.name); });
            return record;
        });
    }
    return groupListEntity;
};
